export const numberFormat = (number) => {
    if (number == null) {
      return 0
    }
    else {
      const value = number.toString();
      const formattedValue = value.replace(/(\d)(?=(\d{2})+\d$)/g, "$1,");
      return formattedValue
    }
  };